import { forwardRef, useState } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, { Column, FilterPanel, FilterRow, HeaderFilter, Pager, Paging } from 'devextreme-react/data-grid';

import { ActionsRow, OptionDropDown } from 'components/ActionsRow';
import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import DataSource from 'devextreme/data/data_source';

import DeleteTrailerModal from '../modals/DeleteTrailerModal/DeleteTrailerModal';

type Props = {
  dataSource: DataSource;
  onCreate: () => void;
  onEdit: (id: number) => void;
  onDeleted: () => void;
};

const DROP_DOWN_OPTIONS: Array<OptionDropDown> = [
  { type: 'EDIT', name: 'Редактировать', icon: 'edit' },
  { type: 'DELETE', name: 'Удалить', icon: 'trash' },
];

export const TrailerListPage = forwardRef<DataGrid, Props>(({ dataSource, onCreate, onEdit, onDeleted }, ref) => {
  const [visibleDeleteModal, setVisibleDeleteModal] = useState(false);
  const [openIdDelete, setOpenIdDelete] = useState<number | null>(null);

  const handleClickDropDown = (option: OptionDropDown, trailer: any) => {
    if (option.type === 'EDIT') {
      onEdit(trailer.id);
    }
    if (option.type === 'DELETE') {
      setOpenIdDelete(trailer.id);
      setVisibleDeleteModal(true);
    }
  };

  const handleCloseDelete = (visible: boolean) => {
    setVisibleDeleteModal(visible);
    if (!visible) {
      setOpenIdDelete(null);
    }
  };

  return (
    <div>
      <div className="pr-2 pt-1">
        <AppLayoutTop title="">
          <ClaimsProvider claimsBlock={['CanEditTransport']}>
            <Button width={120} text="Добавить" type="default" onClick={onCreate} />
          </ClaimsProvider>
        </AppLayoutTop>
      </div>
      <AppCard>
        <DataGrid
          dataSource={dataSource}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          ref={ref}
        >
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <Column dataField="number" caption="Номер" />

          <Column
            dataField="actions"
            caption=""
            width={120}
            allowFiltering={false}
            allowSorting={false}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditTransport']}>
                  <ActionsRow data={data} actionOptions={DROP_DOWN_OPTIONS} handleClickDropDown={handleClickDropDown} />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>

      <DeleteTrailerModal
        visible={visibleDeleteModal}
        changeVisible={handleCloseDelete}
        id={openIdDelete}
        refresh={onDeleted}
      />
    </div>
  );
});

export default TrailerListPage;
